<div class="trial-insights-component relative">
  <!-- Header -->
  <aux-trial-insights-header [title]="title" [header]="total" [color]="color">
    <!-- Icon -->
    <ng-container icon>
      <document-remove-outline-icon [size]="35" [color]="color"></document-remove-outline-icon>
    </ng-container>
  </aux-trial-insights-header>

  <!-- Legend -->
  <aux-trial-insights-legend [options]="legendOptions"></aux-trial-insights-legend>

  <!-- Divider -->
  <div class="trial-insights-divider full"></div>

  <!-- Table -->
  <aux-trial-insights-table
    [options]="tableOptions"
    [isLoadingRemaining]="isLoadingRemaining"
    [selectedKey]="selectedKey"
    [sortOrder]="sortOrder"
    [changeSelectedKey]="queryService.changeSelectedKey"
    [toggleSortOrder]="queryService.toggleSortOrder"
  ></aux-trial-insights-table>
</div>
